import { Component, OnInit, Input, ElementRef } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {state, trigger, transition, style, animate} from '@angular/animations';

@Component({
  selector: 'code-example',
  templateUrl: './code-example.component.html',
  styleUrls: ['./code-example.component.css'],
})
export class CodeExampleComponent implements OnInit {
  @Input('type')
  public type = 'javascript';

  @Input('src')
  public src = '';

  private _element: any;
  public code: string;

  theme = 'crimson_editor';

  options = {
    showLineNumbers: false,
    showGutter: false,
    maxLines: 1000,
    highlightActiveLine: false,
    printMargin: false
  };

  public loading = false;
  public readOnly = true;

  constructor(element: ElementRef, private _http: HttpClient) {
    this.loading = true;
    this._element = element.nativeElement;
    this._element.addEventListener('click', e => {
      e.stopPropagation();
      e.preventDefault();
    });
  }

  ngOnInit() {
    if (!this.type) {
      this.type = inferTypeFromSrc(this.src);
    }
    if (this.src) {
      const src = `/assets/code/${this.src}`;
      this._http.get(src, {responseType: 'text'}).subscribe(response => {
        if (typeof response == 'string') {
          this.code = (response as string).trim();
          this.loading = false;
        }
      });
    } else {
      console.error('[src] must be set')
    }
  }
}

function inferTypeFromSrc(src: string): string {
  const extName = src.substr(src.lastIndexOf('.'));
  switch (extName) {
    case '.ts': return 'typescript';
    case '.js': return 'javascript';
    case '.html': return 'html';
  }
}



// WEBPACK FOOTER //
// ./src/app/code-example/code-example.component.ts